
export const GET_ROLE = 'constants/client/GET_ROLE';
export const ROLE_SUCCESS = 'constants/client/ROLE_SUCCESS';
export const ROLE_ERROR = 'constants/client/ROLE_ERROR';


export const GET_ROLE_BY_ID = 'constants/client/GET_ROLE_BY_ID';
export const ROLE_BY_ID_SUCCESS = 'constants/client/ROLE_BY_ID_SUCCESS';
export const ROLE_BY_ID_ERROR = 'constants/client/ROLE_BY_ID_ERROR';